import { RiDeleteBinLine, RiEdit2Line } from 'react-icons/ri';
import { Chip, IconButton } from './Ui';

const addressLine = (a) =>
  `${a?.city || ''} ${a?.postalCode ? '-' + a.postalCode + ',' : ','} ${
    a?.state?.label || ''
  }, ${a?.country?.label || ''}.`;

const CardShell = ({
  badge,
  children,
  onEdit,
  onRemove,
  alwaysShowActions = false,
}) => (
  <div className="group flex w-full items-start gap-2">
    <div className="relative w-[90%] space-y-1 rounded-lg border border-gray-200 bg-gray-25 p-4 text-sm font-medium text-gray-800 transition-colors duration-500 group-hover:border-gray-600">
      {!!badge && (
        <div className="absolute right-3 top-3">
          <Chip>{badge}</Chip>
        </div>
      )}
      {children}
    </div>

    <div
      className={`space-y-3 ${
        alwaysShowActions ? 'block' : 'hidden group-hover:block group-focus-within:block'
      }`}
    >
      {onEdit && (
        <IconButton aria-label="Edit" onClick={onEdit}>
          <RiEdit2Line size={20} />
        </IconButton>
      )}
      {onRemove && (
        <IconButton aria-label="Remove" intent="error" onClick={onRemove}>
          <RiDeleteBinLine size={20} />
        </IconButton>
      )}
    </div>
  </div>
);



export const LocationCard = ({
  item,
  ...actions
}) => (
  <CardShell badge={item?.locationType} {...actions}>
    {!!item?.address?.street1 && <p>{item.address.street1}</p>}
    {!!item?.address?.street2 && <p>{item.address.street2}</p>}
    <p>{addressLine(item?.address)}</p>
    {!!item?.taxIds?.length && (
      <div>
        <p>Tax IDs:</p>
        {item.taxIds.map((t, i) => (
          <p key={i}>
            {t?.label} : {t?.value}
          </p>
        ))}
      </div>
    )}
  </CardShell>
);

export const BankAccountCard = ({
  item,
  detailed = false,
  ...actions
}) => (
  <CardShell badge={item?.bankType} {...actions}>
    <p>Account Holder: {item?.accountHolderName}</p>
    <p>Bank Name: {item?.bankName}</p>
    <p>Account Number: {item?.accountNumber}</p>
    {detailed && (
      <div className="space-y-0.5 font-mono text-xs font-normal text-gray-500">
        {!!item?.ifscCode && <p>IFSC: {item.ifscCode}</p>}
        {!!item?.swiftBic && <p>SWIFT / BIC: {item.swiftBic}</p>}
        {!!item?.ibanNumber && <p>IBAN: {item.ibanNumber}</p>}
        {!!item?.routingNumber && <p>Routing: {item.routingNumber}</p>}
        {!!item?.nationalBankCode && <p>National code: {item.nationalBankCode}</p>}
      </div>
    )}
    {!!item?.bankAddress?.street1 && <p>{item.bankAddress.street1}</p>}
    {!!item?.bankAddress?.street2 && <p>{item.bankAddress.street2}</p>}
    <p>{addressLine(item?.bankAddress)}</p>
  </CardShell>
);